module.exports = __webpack_public_path__ + "static/img/14010002.0d607ad0.png";